export default __webpack_public_path__ + "static/media/searchIcon.0e00b33c.svg";